import React from 'react';
import { FormControl, FormLabel, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled TextField that matches the design in the screenshot
const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'hasError'
})(({ theme, hasError }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'white',
    '& fieldset': {
      borderColor: hasError ? '#ff3d57' : '#e0e0e0',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: hasError ? '#ff3d57' : '#b0b0b0',
    },
    '&.Mui-focused fieldset': {
      borderColor: hasError ? '#ff3d57' : theme.palette.primary.main,
      borderWidth: '1px',
    },
    '& input': {
      padding: '8px 12px',
      fontSize: '14px',
      borderRadius: '5px',

      '&:disabled': {
        backgroundColor: '#E4E9F0'
      }
    },
    '&.Mui-disabled': {
      backgroundColor: (props) => props.bgcolor || '#f0f4f8',
      '& fieldset': {
        borderColor: '#e0e0e0',
      },
    },
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    fontSize: '12px',
    lineHeight: '1.2',
    marginTop: '2px',
  },
}));

const SuiInputV2 = ({
  id,
  name,
  label,
  required = false,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  error = null,
  touched = false,
  inputSettings = {},
  disabled = false,
  bgcolor,
  InputProps = {},
  customSx = {},
  ...restProps
}) => {
  // Only show error if field is touched and there is an error
  const hasError = touched && Boolean(error);
  const errorMessage = touched && error ? error : '';
  
  return (
    <FormControl fullWidth error={hasError} {...restProps} sx={{ m: 0 }}>
      {label && (
        <FormLabel 
          htmlFor={id} 
          required={required}
          sx={{ 
            fontSize: '14px', 
            mb: 0.5,
            color: 'primary.main',
            '&.Mui-focused': {
              color: 'primary.main',
            }
          }}
        >
          {label}
        </FormLabel>
      )}
      <StyledTextField
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value === undefined ? '' : value}
        onChange={onChange}
        onBlur={onBlur}
        hasError={hasError}
        required={required}
        fullWidth
        title={value}
        variant="outlined"
        error={hasError}
        helperText={errorMessage}
        disabled={disabled}
        bgcolor={bgcolor}
        size="small"
        inputProps={inputSettings}
        InputProps={InputProps}
        sx={{ 
          m: 0,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: hasError ? "#ff3d57" : undefined
          },
          ...customSx
        }}
      />
    </FormControl>
  );
};

export default SuiInputV2;